import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const TabItem = ({ id, label, activeTab, setActiveTab, setFilter }) => {
  const handleClick = () => {
    setActiveTab(id);
    setFilter(label);
  };
  return (
    <li
      onClick={handleClick}
      className={`tab-item ${activeTab === id ? "-active" : ""}`}
      aria-hidden
    >
      {label}
    </li>
  );
};

TabItem.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.string.isRequired,
  setFilter: PropTypes.string.isRequired,
};

export default TabItem;
